var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer-addon"},[_c('el-input',{attrs:{"type":"textarea","rows":6},model:{value:(_vm.disclaimer),callback:function ($$v) {_vm.disclaimer=$$v},expression:"disclaimer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }